import get from 'lodash/get';
import { getInstance as getBootstrap } from 'utils/bootstrap';
import Logger from 'observability/Logger';

export const HOMEPAGE_DOMAIN = 'homepageDomain';
export const HOMEPAGE_URL = 'homepageUrl';
export const OCB_DOMAIN = 'ocbDomain';

const LOG = new Logger('getDomains');

const bootstrap = getBootstrap();

const domains = {
    [HOMEPAGE_DOMAIN]: bootstrap.get(HOMEPAGE_DOMAIN) || get(window, 'splash.server.constants.homepageDomain', null),
    [HOMEPAGE_URL]: bootstrap.get(HOMEPAGE_URL) || get(window, 'splash.server.constants.homepageUrl', null),
    [OCB_DOMAIN]: bootstrap.get(OCB_DOMAIN) || get(window, 'splash.server.constants.ocbDomain', null),
};

export default function getDomain(domainType) {
    if (domains[domainType]) {
        return domains[domainType];
    }

    if (!__TESTING__) {
        LOG.debug(`ERROR: Error loading the domain ${domainType}`);
    }

    return 'splashthat.com';
}

export const getHomepageUrl = () => getDomain(HOMEPAGE_URL);
export const getOcbDomain = () => getDomain(OCB_DOMAIN);
